import { useState } from "react";
import { BookOpen, ChevronDown, ChevronUp } from "lucide-react";
import { GUIDE } from "../pages/AjudaTab";

const TAB_GUIDE = {
  dashboard: "painel", pacientes: "pacientes", viagem: "orcamento", orcamentos: "meus-orcamentos",
  rotas: "rotas", rastreamento: "rastreamento", profissionais: "profissionais", veiculos: "profissionais",
  financeiro: "financeiro", eventos: "eventos", servicos: "servicos", assinatura: "assinatura", usuarios: "usuarios", empresa: "empresa",
};

export const PageGuide = ({ tab }) => {
  const key = `rs_guide_closed_${tab}`;
  const [closed, setClosed] = useState(() => localStorage.getItem(key) === "1");
  const sec = GUIDE.find((g) => g.id === TAB_GUIDE[tab]);
  if (!sec) return null;
  const steps = tab === "profissionais" ? sec.steps.slice(0, 1) : tab === "veiculos" ? sec.steps.slice(1) : sec.steps;
  const toggle = () => { const v = !closed; setClosed(v); localStorage.setItem(key, v ? "1" : "0"); };
  return (
    <div className={`page-guide ${closed ? "closed" : ""}`} data-testid={`page-guide-${tab}`}>
      <button className="page-guide-head" onClick={toggle} data-testid={`page-guide-toggle-${tab}`} aria-expanded={!closed}>
        <BookOpen size={17} />
        <strong>Como usar esta página</strong>
        <span>{closed ? "Mostrar" : "Recolher"}</span>
        {closed ? <ChevronDown size={17} /> : <ChevronUp size={17} />}
      </button>
      {!closed && (
        <ol className="page-guide-steps" data-testid={`page-guide-steps-${tab}`}>
          {steps.map((t, i) => <li key={i}>{t}</li>)}
        </ol>
      )}
    </div>
  );
};
